import {t} from "@lingui/core/macro";

const strings = {
    defaultTitle: () => t`Generating...`,
    defaultDescription: () => t`This may take a couple of minutes.`,
    emptyFieldError: () => t`This field cannot be blank.`,
    htmlTagError: () => t`This field cannot contain HTML tags.`,
    duplicateAnswerError: () => t`Duplicate answers are not allowed.`,
};

export default strings;
